<ng-container *ngIf="product$ | async">
  <ish-product-tile *ngIf="isTile" />
  <ish-product-row *ngIf="isRow" />
</ng-container>

<ish-loading *ngIf="loading$ | async" />
